import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Add a new location
 * @primary Location form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/locations/new")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
